export default function mapPropsToValues() {
  return {
    firstName: "",
    lastName: "",
    email: "",
    verizonContact: "",
    phone: "",
    country: "",
    company: "",
    employmentTitle: "",
    customEmploymentTitle: null,
    priorityCompliance: "No",
    password: "",
    passwordConfirm: "",
    recaptchaToken: null,
  };
}
